import React, {useState, useEffect} from "react";
import CancelButton from "../../../components/forms/cancelButton";
import SaveButton from "../../../components/forms/saveButton";
import QuestionCardAdmin from "../../card/questionCardAdmin";
import DateRangeFormField from "../dateRangeFormField";
import { registerSurvey } from "../../../client/surveys";
import { useAuth } from "../../../context/auth";
import ModalAlertWarning from "../../shared/modals/modalAlertWarning";
import ModalSuccess from "../../shared/modals/modalSuccess";

const CreateFormScreen = ({
  onBack,
  onCreate,
  onFormSaved,
  duplicateData = null,
  isDuplicating = false,
  originalTitle = "",
 }) => {  
  const { user } = useAuth();

  const [title, setTitle] = useState(
    duplicateData ? `${duplicateData.title}` : ''
  );
  const [description, setDescription] = useState(
    duplicateData ? duplicateData.description : ''
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayString = today.toISOString().split('T')[0];

const [dateRange, setDateRange] = useState(() => {
  if (duplicateData) {
    return {
      startDate: todayString, 
      endDate: '' 
    };
  } else {
    return {
      startDate: todayString,
      endDate: ''
    };
  }
});

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false); 
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); 
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [savedFormData, setSavedFormData] = useState(null);
  const [createdSurveyId, setCreatedSurveyId] = useState(null);

  const [questions, setQuestions] = useState([
    { 
      id: 1, 
      data: {
        isRequired: false,
        options: [
          { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
          { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
        ],
        selectedOption: null,
        selectedOptions: [],
        uploadedImage: null,
        imagePreview: null,
        questionTitle: "",
        selectedFormat: 2,
        branches: {}
      }, 
      order: 1 
    }
  ]);

  useEffect(() => {
    if (duplicateData) {
      loadDuplicateData(duplicateData);
    }
  }, [duplicateData]);


const loadDuplicateData = (data) => {
  try {
    setTitle(`${data.title}`);
    setDescription(data.description || '');

    if (data.questions && data.questions.length > 0) {
      const formattedQuestions = data.questions.map((question, index) => {
        const questionData = {
          isRequired: question.obligatory || false,
          questionTitle: question.text || "",
          selectedFormat: question.formatId || 1,
          uploadedImage: null,
          imagePreview: null,
          selectedOption: null,
          selectedOptions: [],
          branches: processBranchesForQuestion(question.branches || [])
        };

        if ((question.formatId === 2 || question.formatId === 3) && question.options) {
          const options = question.options.map((opt, optIndex) => ({
            id: optIndex + 1,
            text: opt.text,
            placeholder: `Opción ${optIndex + 1}`,
            isAddOption: false,
            isOtherOption: false
          }));

          // Agregar opción "Otros" si existe en los datos originales
          if (question.hasOtherOption) {
            options.push({
              id: options.length + 1,
              text: "Otro",
              placeholder: "Otro",
              isAddOption: false,
              isOtherOption: true
            });
          }


          options.push({
            id: options.length + 1,
            text: "",
            placeholder: "Agregar una opción",
            isAddOption: true,
            isOtherOption: false
          });

          questionData.options = options;
        } else {
          questionData.options = [
            { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
            { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
          ];
        }

        return {
          id: index + 1,
          data: questionData,
          order: index + 1
        };
      });

      setQuestions(formattedQuestions);
    }
  } catch (error) {
    console.error("Error loading duplicate data:", error);
  }
};

const processBranchesForQuestion = (branches) => {
  const branchMap = {};
  
  
  branches.forEach(branch => {

    const optionText = branch.openValue;
    
    const optionIndex = branches.indexOf(branch);
    const optionId = optionIndex + 1; 
    
    if (!branchMap[optionId]) {
      branchMap[optionId] = [];
    }
    
    const branchQuestion = {
      id: branch.id || Date.now() + Math.random(),
      data: {
        isRequired: branch.obligatory || false,
        questionTitle: branch.text || "",
        selectedFormat: branch.formatId || 2,
        uploadedImage: null,
        imagePreview: null,
        selectedOption: null,
        selectedOptions: [],
        branches: processBranchesForQuestion(branch.branches || []),
        options: formatOptionsForBranch(branch.options || [], branch.formatId)
      },
      order: branch.order || 1
    };

    branchMap[optionId].push(branchQuestion);
  });
  
  return branchMap;
};

const formatOptionsForBranch = (apiOptions, formatId, hasOtherOption= false) => {
  if ((formatId === 2 || formatId === 3) && apiOptions && apiOptions.length > 0) {
    const options = apiOptions.map((opt, optIndex) => ({
      id: optIndex + 1,
      text: opt.text || "",
      placeholder: `Opción ${optIndex + 1}`,
      isAddOption: false,
      isOtherOption: false
    }));

    if (hasOtherOption) {
      options.push({
        id: options.length + 1,
        text: "Otro",
        placeholder: "Otro", 
        isAddOption: false,
        isOtherOption: true
      });
    }


    options.push({
      id: options.length + 1,
      text: "",
      placeholder: "Agregar una opción",
      isAddOption: true,
      isOtherOption: false
    });

    return options;
  } else {
    const defaultOptions = [
      { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
      { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
    ];
    
    return defaultOptions;
  }
};


const updateQuestionData = (questionId, newData) => {
  setQuestions(prevQuestions => 
    prevQuestions.map(question => 
      question.id === questionId 
        ? { ...question, data: newData }
        : question
    )
  );
};
const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

const formatQuestionForApi = async (questionData, order = 1) => {
  if (!questionData || !questionData.questionTitle) return null;
    
  const question = {
    text: questionData.questionTitle,
    obligatory: questionData.isRequired || false,
    order: order,
    formatId: questionData.selectedFormat || 2
  };

  if (questionData.uploadedImage) {
    try {
      const fullBase64 = await convertImageToBase64(questionData.uploadedImage);
      question.image = fullBase64.split(',')[1]; 
    } catch (error) {
      console.error("Error convirtiendo imagen a base64:", error);
    }
  }
    
  if ((questionData.selectedFormat === 2 || questionData.selectedFormat === 3) && questionData.options) {
    // Filtrar opciones válidas (excluyendo las de agregar y obteniendo solo las normales)
    const validOptions = questionData.options.filter(opt => 
      !opt.isAddOption && !opt.isOtherOption && opt.text.trim() !== ""
    );
    
    question.options = validOptions.map(opt => opt.text);
    
    // Verificar si existe una opción "Otros" en las opciones
    const hasOtherOption = questionData.options.some(opt => 
      opt.isOtherOption && opt.text.trim() !== ""
    );
    
    question.hasOtherOption = hasOtherOption;
  }
    
  if (questionData.branches && Object.keys(questionData.branches).length > 0) {
    question.branches = [];
    
    for (const [optionId, branchArray] of Object.entries(questionData.branches)) {
      const option = questionData.options.find(opt => opt.id === parseInt(optionId));
      
      if (option && !option.isAddOption && !option.isOtherOption && option.text.trim() !== "" && Array.isArray(branchArray)) {
        for (let i = 0; i < branchArray.length; i++) {
          const branch = branchArray[i];
          if (branch && branch.data && branch.data.questionTitle && branch.data.questionTitle.trim() !== "") {
            const formattedBranch = await formatQuestionForApi(branch.data, i + 1);
            if (formattedBranch) {
              question.branches.push({
                openValue: option.text,
                ...formattedBranch
              });
            }
          }
        }
      }
    }
    
    if (question.branches.length === 0) {
      delete question.branches;
    }
  }
    
  return question;
};

const prepareSurveyData = async () => {

  const formattedQuestions = await Promise.all(
    questions
      .map(async (question, index) => {
        const formatted = await formatQuestionForApi(question.data, index + 1);
        return formatted;
      })
      .filter(question => question !== null)
  );


  const surveyData = {
    title: title,
    description: description, 
    openingAt: dateRange.startDate,
    closingAt: dateRange.endDate,
    questions: formattedQuestions,
    userIds: [9],
    creatorId: user?.id
  };
  
  return surveyData;
};

  const addNewQuestion = () => {
    const newQuestionId = Math.max(...questions.map(q => q.id), 0) + 1;
    setQuestions([...questions, { 
      id: newQuestionId, 
      data: null, 
      order: questions.length + 1 
    }]);
  };

  const duplicateQuestion = (questionData, questionId) => {
    const newQuestionId = Math.max(...questions.map(q => q.id)) + 1;
    const newQuestions = [...questions];
    
    const currentIndex = newQuestions.findIndex(q => q.id === questionId);
    newQuestions.splice(currentIndex + 1, 0, { 
      id: newQuestionId, 
      data: { ...questionData },
      order: currentIndex + 2
    });
    
    newQuestions.forEach((q, index) => {
      q.order = index + 1;
    });
    
    setQuestions(newQuestions);
  };

  const deleteQuestion = (questionId) => {
    if (questions.length > 1) {
      const newQuestions = questions.filter(q => q.id !== questionId);
      newQuestions.forEach((q, index) => {
        q.order = index + 1;
      });
      setQuestions(newQuestions);
    }
  };

  const handleSaveForm = async () => {
    if (!title.trim()) {
      setErrorMessage("Por favor, ingresa un título para el formulario");
      setShowModalAlertWarning(true);
      return;
    }

    if (!dateRange.startDate || !dateRange.endDate) {
      setErrorMessage("Por favor, selecciona las fechas de inicio y fin");
      setShowModalAlertWarning(true);
      return;
    }

    if (new Date(dateRange.startDate) >= new Date(dateRange.endDate)) {
      setErrorMessage("La fecha de fin debe ser posterior a la fecha de inicio");
      setShowModalAlertWarning(true);
      return;     
    }

    const hasValidQuestions = questions.some(q => 
      q.data && q.data.questionTitle && q.data.questionTitle.trim() !== ""
    );

    if (!hasValidQuestions) {
      setErrorMessage("Por favor, ingresa al menos una pregunta válida");
      setShowModalAlertWarning(true);
      return;
    }

    try {
      setIsSubmitting(true);
      const surveyData = await prepareSurveyData();

      const response = await registerSurvey(surveyData);
      
      if (response.status === 200 || response.status === 201) {
        setSuccessMessage("Encuesta creada exitosamente");
        setShowModalSuccess(true);
        
        const surveyId = response.data.id || response.data.surveyId;
        setCreatedSurveyId(surveyId);
        setSavedFormData(surveyData);
      }

    } catch (error) {
      console.error("Error al crear encuesta:", error);
      let errorMsg = "Error inesperado: " + error.message;
      
      if (error.response) {
        errorMsg = "Error al crear la encuesta: " + (error.response.data.message || error.response.statusText);
      } else if (error.request) {
        errorMsg = "Error de conexión. Por favor, verifica tu conexión a internet.";
      }
      
      setErrorMessage(errorMsg);
      setShowModalAlertWarning(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDateRangeChange = (dates) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    setDateRange({
      startDate: dates.startDate,
      endDate: dates.endDate
    });
  };

  const handleSuccessModalClose = () => {
    setShowModalSuccess(false);
    
    if (onFormSaved && savedFormData && createdSurveyId) {
      onFormSaved(savedFormData, createdSurveyId);
    }
  };

  const handleWarningModalClose = () => {
    setShowModalAlertWarning(false);
  };

  return (
    <div>
      <div className="flex flex-col w-full gap-4 pt-2">
        <div className="flex flex-col items-center justify-between w-full gap-3 md:flex-row">
          <input 
            className="w-full text-2xl bg-transparent outline-none focus:border-b-2 focus:border-blue hover:border-b hover:border-blue text-blue font-itcbook placeholder:text-2xl placeholder:text-blue placeholder:font-itcbook"
            placeholder="Título del formulario *"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            disabled={isSubmitting}
            maxLength={50}
          />
          <div className="md:w-[350px]">
            <DateRangeFormField 
              required
              onDateRangeChange={handleDateRangeChange}
              value={dateRange}
              disabled={isSubmitting}
              minDate={new Date()}
            />
          </div>
        </div>

        <input 
          className="text-xl bg-transparent outline-none focus:border-[#6B7280] hover:border-[#6B7280] focus:border-b-2 hover:border-b font-itcbook placeholder:text-xl placeholder:text-[#6B7280] placeholder:font-itcbook "
          placeholder="Descripción del formulario"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={isSubmitting}
          maxLength={200}
        />
  
        {questions.map((question, index) => (
          <QuestionCardAdmin 
            key={question.id}
            questionData={question.data}
            onCopy={(data) => duplicateQuestion(data, question.id)}
            onDelete={() => deleteQuestion(question.id)}
            onUpdate={(data) => updateQuestionData(question.id, data)} 
            showDeleteButton={questions.length > 1}
          />
        ))}

        <div className="flex justify-center mt-4">
          <button 
            onClick={addNewQuestion}
            disabled={isSubmitting}
            className={`px-6 py-2 transition-colors border rounded-lg font-itcmedium ${
              isSubmitting 
                ? 'text-gray-400 border-gray-400 cursor-not-allowed' 
                : 'text-blue border-blue hover:bg-blue hover:text-white'
            }`}
          >
            + Agregar nueva pregunta
          </button>
        </div>


        <div className="flex items-center justify-center w-full gap-4">
          <SaveButton 
            title={isSubmitting ? "Guardando..." : "Guardar"} 
            onClick={handleSaveForm} 
            disabled={isSubmitting} 
          />
          <CancelButton onClick={onBack} disabled={isSubmitting}/>
        </div>
      </div>

      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={handleWarningModalClose}
        error={errorMessage}
        accept={handleWarningModalClose}
      />

      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={handleSuccessModalClose}
        fill="green" 
        text={successMessage}
      />
    </div>
  );
  
};

export default CreateFormScreen;